import { render, staticRenderFns } from "./ClassroomDashboard.vue?vue&type=template&id=f75a5390&scoped=true"
import script from "./ClassroomDashboard.vue?vue&type=script&lang=js"
export * from "./ClassroomDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDashboard.vue?vue&type=style&index=0&id=f75a5390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75a5390",
  null
  
)

export default component.exports